// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"f0fbd668","80":"c7017728","111":"aa9e75ce","176":"24315163","222":"12f500f0","384":"bc1bd9ae","607":"531355ef","699":"4aa97095","816":"aa96b224","853":"3ae08fb3","924":"2cb795c9","981":"4455da62"}[chunkId] + ".chunk.js";
};